// import CryptoJS from 'crypto-js';
export const AES_KEY = 'Ls7pR8WK5iHrg6yC';
export const AES_IV = '8bTOPnMuwzyKm9IB';

export const safeUrlBase64Encrypt = (plaintext) => {
  try {
    // Convert key and iv to WordArray
    const keyWordArray = CryptoJS.enc.Utf8.parse(AES_KEY);
    const ivWordArray = CryptoJS.enc.Utf8.parse(AES_IV);

    // Encrypt using AES-128-CBC
    const encrypted = CryptoJS.AES.encrypt(plaintext, keyWordArray, {
      iv: ivWordArray,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Get the encrypted data as Base64
    const base64 = encrypted.toString();

    // Convert to URL-safe Base64 (+ → -, / → _, remove =)
    const urlSafeBase64 = base64
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=/g, '');

    return urlSafeBase64;
  } catch (error) {
    console.log('Encryption error:', error);
    return null;
  }
}

export const safeUrlBase64Decrypt = (cipherText) => {
  try {
    // Convert URL-safe Base64 back to standard Base64
    let base64 = cipherText.replace(/-/g, '+').replace(/_/g, '/');

    // Add padding if needed
    while (base64.length % 4) {
      base64 += '=';
    }

    // Convert key and iv to WordArray
    const keyWordArray = CryptoJS.enc.Utf8.parse(AES_KEY);
    const ivWordArray = CryptoJS.enc.Utf8.parse(AES_IV);

    // Decrypt
    const decrypted = CryptoJS.AES.decrypt(base64, keyWordArray, {
      iv: ivWordArray,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.log('Decryption error:', error);
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/assets/lib/crypto.js